module.exports = __webpack_public_path__ + "static/media/shopping-cart.e13804a2.svg";